import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { i as iframeInputStylesSet } from './iframe-input-styles-state.js';
import { Q as inputInvalidAndFocused, b as inputInvalid, d as inputFocused, i as input } from './parts.js';

const HiddenInput = /*@__PURE__*/ proxyCustomElement(class HiddenInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.isFocused = false;
        this.errorText = '';
    }
    async componentDidLoad() {
        const fontStyles = await this.getBaseFontStyles();
        iframeInputStylesSet('fontStyles', fontStyles);
        const focusedStyles = await this.getFocusedStyles();
        iframeInputStylesSet('focused', focusedStyles);
        const focusedAndInvalidStyles = await this.getFocusedAndInvalidStyles();
        iframeInputStylesSet('focusedAndInvalid', focusedAndInvalidStyles);
    }
    async getBaseFontStyles() {
        return new Promise((resolve, _reject) => {
            setTimeout(() => {
                const computedStyles = getComputedStyle(this.hiddenInput);
                const styles = {
                    fontFamily: computedStyles.fontFamily,
                    fontSize: computedStyles.fontSize,
                    fontWeight: computedStyles.fontWeight,
                    lineHeight: computedStyles.lineHeight,
                    margin: computedStyles.margin,
                    padding: computedStyles.padding,
                    color: computedStyles.color,
                };
                resolve(styles);
            }, 500);
        });
    }
    ;
    async getFocusedStyles() {
        return new Promise((resolve, _reject) => {
            this.hiddenInput.focus();
            setTimeout(() => {
                this.hiddenInput.blur();
                let computedStyles = getComputedStyle(this.hiddenInput);
                resolve({
                    boxShadow: computedStyles.boxShadow,
                    border: computedStyles.border,
                });
            }, 500);
        });
    }
    async getFocusedAndInvalidStyles() {
        return new Promise((resolve, _reject) => {
            this.hiddenInput.focus();
            this.errorText = 'Error';
            setTimeout(() => {
                const computedStyles = getComputedStyle(this.hiddenInput);
                const styles = {
                    boxShadow: computedStyles.boxShadow,
                    border: computedStyles.border,
                };
                this.hiddenInput.blur();
                resolve(styles);
            }, 500);
        });
    }
    get part() {
        if (this.isFocused && this.errorText) {
            return inputInvalidAndFocused;
        }
        if (this.errorText) {
            return inputInvalid;
        }
        if (this.isFocused) {
            return inputFocused;
        }
        return input;
    }
    render() {
        return (h(Host, { key: '04cbd78b739016b2a97a37a35df53bed83184e3d' }, h("input", { key: '6266b0dcfeeb13bd522fdd46b854300ccbadda4d', ref: el => this.hiddenInput = el, type: "text", class: this.errorText ? "form-control is-invalid" : "form-control", onFocus: () => this.isFocused = true, onBlur: () => this.isFocused = false, part: this.part, tabindex: "-1", style: { height: '0', opacity: '0', pointerEvents: 'none', animation: 'none' } })));
    }
}, [0, "hidden-input", {
        "isFocused": [32],
        "errorText": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["hidden-input"];
    components.forEach(tagName => { switch (tagName) {
        case "hidden-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, HiddenInput);
            }
            break;
    } });
}
defineCustomElement();

export { HiddenInput as H, defineCustomElement as d };
